module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-14.c74d0f09.webp";